<span class="cm-table-cell"
	[ngStyle]="{'justify-content': col.justify === 'end' ? 'flex-end' : col.justify === 'center' ? 'center' : 'flex-start'}">
	<ng-container [ngSwitch]="true">
		<ng-container *ngSwitchCase="col.type === 'link'">
			<ng-container *ngIf="col.link(element) as linkStr; else default">
				<ng-container *ngIf="col.routerLink; else externalTpl">
					<a [routerLink]="linkStr" [target]="col.linkTarget"
						[queryParams]="col.queryParams ? col.queryParams(element) : null"
						[attr.aria-label]="col.linkAriaLabel ? col.linkAriaLabel(element) : null">
						{{ element[col.field] }}
					</a>
				</ng-container>
				<ng-template #externalTpl>
					<a [href]="linkStr" [target]="col.linkTarget"
						[attr.aria-label]="col.linkAriaLabel ? col.linkAriaLabel(element) : null">
						<span>
							{{ element[col.field] }}
						</span>
						<ats-icon *ngIf="col.linkTarget === '_blank'" name="external" [size]="12" class="ml-4">
						</ats-icon>
					</a>
				</ng-template>
			</ng-container>
			<ng-template #default>
				{{ element[col.field] }}
			</ng-template>
		</ng-container>
		<ng-container *ngSwitchCase="col.type === 'image' ">
			<div class="image-cell">
				<img [src]="element[col.field]" alt="" class="image-cell__img">
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="col.type === 'action'">
			<span class="action-cell">
				<ng-container *ngFor="let action of col.actions"
					[ngTemplateOutlet]="(action | atsPropHasValue: 'run') ? actionButton : downloadButton"
					[ngTemplateOutletContext]="{$implicit: action, col: col}"></ng-container>
			</span>
		</ng-container>
		<ng-container *ngSwitchDefault>
			<ng-container>{{ element[col.field] }}</ng-container>
		</ng-container>
	</ng-container>
</span>

<ng-template #actionButton let-action let-col="col">
	<button mat-button cm-mini-button
		[attr.aria-label]="action.ariaLabel ? action.ariaLabel({ row: element, column: col, action: action }) : action.label"
		[color]="action.color === 'success' ? null : action.color || null"
		[ngClass]="{'success': action.color === 'success'}" (click)="action.run({ row: element, column: col })">
		<ng-container [ngTemplateOutlet]="actionButtonContent" [ngTemplateOutletContext]="{$implicit: action}">
		</ng-container>
	</button>
</ng-template>

<ng-template #downloadButton let-action let-col="col">
	<button *ngIf="element[col.field]" mat-button cm-mini-button
		[attr.aria-label]="action.ariaLabel ? action.ariaLabel({ row: element, column: col, action: action }) : action.label"
		[color]="action.color === 'success' ? null : action.color || null"
		[ngClass]="{'success': action.color === 'success'}" [cmFileDownload]="element[col.field]"
		[targetWindow]="action.target || '_blank'">
		<ng-container [ngTemplateOutlet]="actionButtonContent" [ngTemplateOutletContext]="{$implicit: action}">
		</ng-container>
	</button>
</ng-template>

<ng-template #actionButtonContent let-action>
	<ats-icon *ngIf="action.icon" [name]="action.icon" [matTooltip]="action.showText? null: action.label"
		[attr.aria-label]="action.label">
	</ats-icon>
	<span *ngIf="(!action.icon || action.showText)" [ngClass]="{'ml-8': !!action.icon}">
		{{ action.label }}
	</span>
</ng-template>
